import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { FOUNDER, faqSchema, pageHead, SITE_URL } from "@/lib/seo";

const c = landingPages["a-propos"]!.en!;

export const Route = createFileRoute("/en/a-propos")({
  head: () =>
    pageHead({
      path: "/en/a-propos",
      title: c.title,
      description: c.description,
      crumbs: [["About", "/en/a-propos"]],
      schemas: [
        {
          "@context": "https://schema.org",
          ...FOUNDER,
          knowsLanguage: ["fr", "en"],
          worksFor: { "@type": "Organization", name: "CMO Partner", url: SITE_URL },
        },
        ...(c.faq?.length ? [faqSchema(c.faq)] : []),
      ],
    }),
  component: () => <LandingPage pageKey="a-propos" forceLanguage="en" pathOverride="/en/a-propos" />,
});
